// This file is auto-generated by scripts/generate-version.js
// Do not edit manually - it will be overwritten on build

export const version = {
  gitCommit: 'a25e1078c',
  buildTime: '2026-11-04T01:51:38.214Z',
} as const;
